import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Loucas por Beleza</h3>
            <p>Sua loja online de produtos de beleza</p>
          </div>
          <div className="footer-section">
            <h4>Links Rápidos</h4>
            <ul>
              <li><a href="https://www.loucasporbeleza.com.br" target="_blank" rel="noreferrer">Home - www.loucasporbeleza.com.br</a></li>
              <li><Link to="/produtos">Produtos</Link></li>
              <li><Link to="/cadastro-cliente">Cadastro</Link></li>
              <li><a href="#contato">Contato</a></li>
            </ul>
          </div>
          <div className="footer-section" id="contato">
            <h4>Contato</h4>
            <p>Telefone: (12) 99175-7395</p>
            <p>Email: loucasporbelezaofficial@gmail.com</p>
            <p>Instagram: <a href="https://instagram.com/loucasporbelezaofficial" target="_blank" rel="noreferrer">@loucasporbelezaofficial</a></p>
            <p>Facebook: <a href="https://facebook.com/loucasporbelezaofficial" target="_blank" rel="noreferrer">loucasporbelezaofficial</a></p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 Loucas por Beleza. Todos os direitos reservados. CodeWareBR Consultoria e Desenvolvimento.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

